import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import config from 'constants/config'
import productLabels from 'i18n/productLabels'

function usePurchaseSynonymLabels() {
  const intl = useIntl()
  const purchaseSynonym = config.brandConfig.purchaseSynonym

  return useMemo(() => {
    const purchaseSynonymLabel = (() => {
      if (purchaseSynonym === 'escape') {
        return intl.formatMessage({
          id: '_-LctDusvWHodg4uAX_m',
          defaultMessage: 'escape',
          description: 'Singular purchase synonym shown in customer-facing booking confirmation messages for escape-branded sites',
        })
      }

      if (purchaseSynonym === 'booking') {
        return intl.formatMessage({
          id: '8al1kKfjH2cn62pVff34',
          defaultMessage: 'booking',
          description: 'Singular purchase synonym shown in customer-facing booking confirmation messages for booking-branded sites',
        })
      }

      return intl.formatMessage({
        id: 'gzIWi6mGb4bVGj68G4kJ',
        defaultMessage: 'purchase',
        description: 'Singular purchase synonym shown in customer-facing booking confirmation messages for purchase-branded sites',
      })
    })()

    const myPurchases = (() => {
      if (purchaseSynonym === 'escape') {
        return intl.formatMessage(productLabels.myEscapes)
      }

      if (purchaseSynonym === 'booking') {
        return intl.formatMessage({
          id: 'uN-vVoJGfR6Xi1K4E_q6',
          defaultMessage: 'My Bookings',
          description: 'My escapes button text in navigation bar when purchaseSynonym is booking',
        })
      }

      return intl.formatMessage({
        id: '-QOPCZu2uRwE-x1yuuqc',
        defaultMessage: 'My Purchases',
        description: 'My escapes button text in navigation bar when purchaseSynonym is purchase',
      })
    })()

    return { myPurchases, purchaseSynonym: purchaseSynonymLabel }
  }, [intl, purchaseSynonym])
}

export default usePurchaseSynonymLabels
